
export default function ZanskarWeather() {
    return (
        <div >
            <a class="weatherwidget-io" href="https://forecast7.com/en/33d5676d99/zanskar/" data-label_1="ZANSKAR" data-label_2="WEATHER" data-font="Play" data-icons="Climacons Animated" data-days="7" data-theme="blue-mountains" >ZANSKAR WEATHER</a>
        </div>
    )
}